import Call from '../Call';
import {objToQs} from '../Utils';

const Users = {
    getPage(page,filters) {
        return Call(`users/${page}?${objToQs(filters)}`);
    },

    getCountries() {
        return Call(`users/countries`)
    },

    count(filters) {
        filters = Object.assign({}, filters);

        if(filters.countries && filters.countries.length) filters.countries = JSON.stringify(filters.countries);
        return Call(`users/count/?${objToQs(filters)}`);
    },

    count2() {
        return Call(`users/count2`);
    },

    countLive() {
        return Call(`users/count/live`);
    },

    getDaySubscribeStats(day) {
        return Call(`users/daySubscribeStats/${day}`);
    }
}

export default Users;


// WEBPACK FOOTER //
// ./src/services/API/components/Users.js